/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import TextField from '@material-ui/core/TextField';
import { SearchResultHeads } from './tableHeads';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import { getZeroURAResult } from '../Store/action';
export default function DispZeroURA() {
  const [fullScreenView, setfullScreenView] = React.useState(false);
  const dispatch = useDispatch();
  const handleFullScreenView = () => {
    setfullScreenView(!fullScreenView);
  };
  const [searchResultList, setSearchResultList] = React.useState([]);

  const {
    quarterValue,
    manufacturerSelectedId,
    manufacturerSelectedName,
    searchResult,
    rebateProgrameName,
  } = useSelector((state) => state?.sharedState?.ZeroURAReducer);

  //TO get the complete name of the rebate program
  let rebateProgramNameValue = rebateProgrameName;
  //   rebateProgramList?.find(
  //     (item) => item.rebateProgramCd === rebateProgramValue
  //   ) || '';
  // rebateProgramNameValue = `${
  //   rebateProgramNameValue?.rebateProgramCd || ''
  // } - ${rebateProgramNameValue?.shortDescr || ''}`;

  //PDF Header
  let firstInfo = `Quarter : ${quarterValue}`;
  let secondInfo = `Manufacturer : ${
    manufacturerSelectedId === 'ALL'
      ? manufacturerSelectedId
      : manufacturerSelectedName
  }`;
  let thirdInfo = `${rebateProgramNameValue}`;

  return (
    <div className="tabs-container">
      {!fullScreenView && (
        <CustomSeparator parent1="State Reports" parent2="Display Zero URA" />
      )}
      {!fullScreenView && (
        <div className="tab-body custom-search-dates">
          <div className="mui-custom-form input-md field-xl">
            <div className="row mb-2">
              <div className="col-6">
                <TextField
                  label="Rebate Program : "
                  id="rebateProgram"
                  fullWidth
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={rebateProgramNameValue}
                  name="RebateProgram"
                  disabled
                />
              </div>
              <div className="col-6">
                <TextField
                  label="Quarter : "
                  id="qtrValue"
                  fullWidth
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={quarterValue}
                  name="quarterValue"
                  disabled
                />
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-6">
                <TextField
                  label="Manufacturer : "
                  id="manufact"
                  fullWidth
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={
                    manufacturerSelectedId === 'ALL'
                      ? manufacturerSelectedId
                      : manufacturerSelectedName
                  }
                  name="RebateProgram"
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
      )}
      <TableGridWithFeatures
        columnDefs={SearchResultHeads}
        rowData={searchResult || []}
        showSearchInfo={true}
        rowMultiSelectWithClick={true}
        enterMovesDown
        data-testid="onEditingStopped"
        showResetFilter={false}
        handleViewHistory={false}
        hideTotalCount={false}
        exportFile={true}
        reportName="Zero URA Report"
        fileName="ZeroURA"
        fullScreenView={fullScreenView}
        handleFullScreenViewClick={handleFullScreenView}
        gridHeight={fullScreenView ? '100vh' : viewPortHeight_355}
        info={{ firstInfo, secondInfo, thirdInfo }}
      />
    </div>
  );
}
